import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export default function ComplaintNotifyDialog({ open, onClose }) {
  const [users, setUsers] = useState([]);
  useEffect(() => { if (open) api.get("/complaint-forms/notify").then((r) => setUsers(r.data)); }, [open]);
  const toggle = async (u) => {
    try {
      await api.put(`/complaint-forms/notify/${u.user_id}`, { enabled: !u.notify_complaints });
      setUsers((xs) => xs.map((x) => (x.user_id === u.user_id ? { ...x, notify_complaints: !u.notify_complaints } : x)));
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md bg-white max-h-[85vh] overflow-y-auto" data-testid="complaint-notify-dialog">
        <DialogHeader><DialogTitle>Benachrichtigung bei neuen Beschwerden</DialogTitle></DialogHeader>
        <p className="text-xs text-slate-500">Diese Personen erhalten eine E-Mail, sobald ein Teilnehmer einen Beschwerdebogen absendet.</p>
        <div className="divide-y divide-slate-100 border border-slate-200">
          {users.map((u) => (
            <label key={u.user_id} className="flex items-center gap-3 px-4 py-2.5 text-sm cursor-pointer hover:bg-slate-50" data-testid={`complaint-notify-${u.user_id}`}>
              <input type="checkbox" checked={!!u.notify_complaints} onChange={() => toggle(u)} data-testid={`complaint-notify-toggle-${u.user_id}`} />
              <span className="flex-1">{u.name}<span className="block text-[11px] text-slate-400">{u.email}</span></span>
            </label>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
